import { all, takeEvery } from 'redux-saga/effects';
import * as couponsActions from '../actions';
import fetchCouponsGroup from './worker.fetchCouponsGroup';

function* couponsSaga() {
  yield all([takeEvery([couponsActions.fetchCouponsGroup.type], fetchCouponsGroup)]);
}

export default couponsSaga;
